import { gql } from "@apollo/client"

export const getAllAssessmentMasterQuery = gql`
  query getAssessments(
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllAssessmentMasters(
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        assessmentName
        ageGroupId
        iconURL

        error {
          statusCode
          message
        }
      }
      pagination {
        pageNumber
        pageLimit
        totalCount
      }
    }
  }
`
export const deleteAssessmentMasterMutation = gql`
  mutation deleteAssessment($id: Int!) {
    deleteOneAssessmentMaster(id: $id) {
      id
      status
      error {
        message
      }
    }
  }
`
export const getOneAssessmentMasterQuery = gql`
  query getAssessmentMaster($id: Int!) {
    getOneAssessmentMaster(id: $id) {
      id
      ageGroupId
      assessmentName
      iconURL
    }
  }
`
export const createAssessmentMasterMutation = gql`
  mutation createAssessment($data: assessmentMasterInput) {
    createOneAssessmentMaster(data: $data) {
      id
      status
      error {
        message
      }
    }
  }
`
export const updateAssessmentMasterMutation = gql`
  mutation updateAssessment($id: Int!, $data: assessmentMasterInput) {
    updateOneAssessmentMaster(id: $id, data: $data) {
      id
      status
      error {
        message
      }
    }
  }
`
export const getAllAgeGroup = gql`
  query getAgeGroups(
    $searchString: String
    $pageNumber: Float
    $pageLimit: Float
  ) {
    getAllAgeGroupMasters(
      searchString: $searchString
      pageNumber: $pageNumber
      pageLimit: $pageLimit
    ) {
      items {
        id
        ageGroupTitle
      }
    }
  }
`
export const fileUploadQuery = gql`
  query getUploadUrl($type: String!, $fileName: String!) {
    getUploadUrl(type: $type, fileName: $fileName) {
      status

      url

      error {
        message
      }
    }
  }
`
